import { PriceItem } from '@/features/common/components/Overview/types'
import { priceToPayStyles } from '@/features/pos/components/OrderFinalization/parts/BottomSheet/styles'
import Typography from '@/features/ui/typography'
import { FC, memo } from 'react'
import { View } from 'react-native'

interface PriceItemsListProps {
    items: PriceItem[]
}

const PriceItemsList: FC<PriceItemsListProps> = ({ items }) => {
    return (
        <View style={priceToPayStyles.itemsContent}>
            {items.map((item, index) => (
                <View key={index} style={priceToPayStyles.itemRow}>
                    <Typography.Description
                        numberOfLines={1}
                        size="small"
                        font="regular"
                        style={priceToPayStyles.itemLabel}
                    >
                        {item.label}
                    </Typography.Description>
                    <Typography.Description
                        numberOfLines={1}
                        size="small"
                        font="regular"
                        style={priceToPayStyles.itemPrice}
                    >
                        {item.price}
                    </Typography.Description>
                </View>
            ))}
        </View>
    )
}

export default memo(PriceItemsList)
